/**
 * @generated SignedSource<<c6c020a68d69e9e48a5ac030b6585a64>>
 * @relayHash 4fdb1f894d6df44e4cf39caaffb8cb1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0e4e72ab737980a3ca2f8403bce83b6a5ed72adbe7eada3312127dad645f8d7

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceShareableLinkAccessType = "EXTERNAL" | "INTERNAL_LICENSED" | "%future added value";
export type PublicLinkStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_ORG_DEFAULT_POLICY" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "TRASHED" | "%future added value";
export type SharedContentQuery$variables = {
  contentId?: string | null;
  shareToken: string;
};
export type SharedContentQuery$data = {
  readonly singleContent: {
    readonly accessLinkInfo: {
      readonly accessType: ConfluenceShareableLinkAccessType;
      readonly status: PublicLinkStatus;
    } | null;
    readonly appearancePublished: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly history: {
      readonly createdDate: string | null;
      readonly lastUpdated: {
        readonly when: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly referenceId: string | null;
    readonly space: {
      readonly alias: string | null;
      readonly id: string | null;
      readonly key: string | null;
      readonly name: string | null;
    } | null;
    readonly status: string | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
    readonly version: {
      readonly friendlyWhen: string | null;
    } | null;
  } | null;
};
export type SharedContentQuery = {
  response: SharedContentQuery$data;
  variables: SharedContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareToken"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = {
  "kind": "ScalarField",
  "name": "status"
},
v5 = {
  "kind": "ScalarField",
  "name": "value"
},
v6 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "shareToken",
        "variableName": "shareToken"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "referenceId"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "kind": "ScalarField",
        "name": "subType"
      },
      (v4/*: any*/),
      {
        "concreteType": "ConfluenceAccessLinkInfo",
        "kind": "LinkedField",
        "name": "accessLinkInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "accessType"
          },
          (v4/*: any*/)
        ]
      },
      {
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "createdDate"
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "lastUpdated",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "when"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "friendlyWhen"
          }
        ]
      },
      {
        "alias": "appearancePublished",
        "args": [
          {
            "kind": "Literal",
            "name": "key",
            "value": "content-appearance-published"
          }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "number"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "properties(key:\"content-appearance-published\")"
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "key",
            "value": "editor"
          }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/)
            ]
          }
        ],
        "storageKey": "properties(key:\"editor\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SharedContentQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SharedContentQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "4fdb1f894d6df44e4cf39caaffb8cb1f",
    "id": "a0e4e72ab737980a3ca2f8403bce83b6a5ed72adbe7eada3312127dad645f8d7",
    "metadata": {},
    "name": "SharedContentQuery",
    "operationKind": "query",
    "text": "query SharedContentQuery($shareToken:String!,$contentId:ID){singleContent(shareToken:$shareToken,id:$contentId){id,referenceId,space{id,key,alias,name},title,type,subType,status,accessLinkInfo{accessType,status},history{createdDate,lastUpdated{when}},version{friendlyWhen},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}}}}"
  }
};
})();

(node as any).hash = "2aaa01efb1277573924d9d8cb34989ad";

export default node;
